import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import autoBind from "react-autobind";
import { Row, Col } from "react-bootstrap";
import DDadosItem from "@common/components/ddados/ddados.item";
import { ddadosValidar as DDados } from "../validar.ddados";
import validarSelector from "../store/validar.selectors";
import validarActions from "../store/validar.actions";
import Form from "@common/externos/components/validation/form.validation";
import Card from "@common/externos/components/card/card.externo";
import Recapctcha from "react-recaptcha";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const values = this.props.routerManager.params;

    if (Object.keys(values).length) {
      this.props.validarActions.setFromQueryString({
        CpfCnpj: values.CpfCnpj,
        Exercicio: parseInt(values.Exercicio),
        InscricaoMunicipal: parseInt(values.InscricaoMunicipal),
        CodigoVerificacao: parseInt(values.Cod)
      });
    }
  }

  onSubmit(values) {
    this.props.validarActions.validate(values);
  }

  //Funções de controle do ReCaptcha
  verifyCallback(response) {
    this.props.validarActions.setTokenRecaptcha(response);
  }

  expiredCallback() {
    this.props.validarActions.setTokenRecaptcha("");
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "servicoEmpresa" });
  }

  render() {
    const { Campos, Titulo, prefix } = DDados;
    const { validar } = this.props.validarSelector;

    return (
      <Card className={"pb-0"}>
          <h2 className={"mb-4"}>{Titulo}</h2>
        <Form
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          prefix={prefix}
        >
          {form => (
            <Fragment>
              <Row>
                <Col lg={"4"}>
                  <DDadosItem
                    name="InscricaoMunicipal"
                    {...Campos.InscricaoMunicipal}
                    state={validar.DadosValidar}
                  />
                </Col>
                <Col lg={"4"}>
                  <DDadosItem
                    name="CpfCnpj"
                    {...Campos.CpfCnpj}
                    state={validar.DadosValidar}
                  />
                </Col>
                <Col lg={"2"}>
                  <DDadosItem
                    name="Exercicio"
                    {...Campos.Exercicio}
                    state={validar.DadosValidar}
                  />
                </Col>
                <Col lg={"2"}>
                  <DDadosItem
                    name="CodigoVerificacao"
                    {...Campos.CodigoVerificacao}
                    state={validar.DadosValidar}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} lg={4}>
                  <Recapctcha
                    // ref={e => (recaptchaInstance = e)}
                    sitekey={"6LeSHQETAAAAACjgu00LxcbscsmkkwMIqhfd1-Gh"}
                    verifyCallback={this.verifyCallback}
                    render={"explicit"}
                    expiredCallback={this.expiredCallback}
                    hl="pt-br"
                    theme="light"
                    size="normal"
                  />
                </Col>
              </Row>
          </Fragment>
            )}
        </Form>
      </Card>
    );
  }
}

export default connect({
  actions: {
    validarActions
  },
  selectors: {
    validarSelector
  }
})(Container);
